export default {
    namespaced: true,
    state: () => ({
        Projects: [{
                target: '[data-v-step="0"]',
                content: "Set up your account details",
                params: {
                    placement: "left",
                },
            },
            {
                target: '[data-v-step="1"]',
                content: "Click to check Project General Information",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="2"]',
                content: "Click to Keep control on Project phases advance",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="3"]',
                content: "and how the consulting time is used",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="4"]',
                content: "Get in touch with your consultant",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="5"]',
                content: "Check your notifications",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="6"]',
                content: "Go to your project outline ",
                params: {
                    placement: "bottom",
                },
            },
        ],
        UserConfigure: [{
                target: '[data-v-step="18"]',
                content: "Set up your details and click save",
                params: {
                    placement: "bottom",
                },
            },
            {
                target: '[data-v-step="17"]',
                content: "Click on project to return main screen",
                params: {
                    placement: "bottom",
                },
            }
        ],
        DashBoard: [{
                target: '[data-v-step="7"]',
                content: "Chech your project phases And project processes",
                params: {
                    placement: "right",
                }
            },
            {
                target: '[data-v-step="9"]',
                content: "Select the process to manage",
                params: {
                    placement: "left",
                }
            },
            {
                target: '[data-v-step="10"]',
                content: "View a process description",
                params: {
                    placement: "right",
                }
            },
            {
                target: '[data-v-step="11"]',
                content: "Know the relevance in the project",
                params: {
                    placement: "right",
                }
            },
            {
                target: '[data-v-step="12"]',
                content: "Check and upload the required for analysis",
                params: {
                    placement: "right",
                }
            },
            {
                target: '[data-v-step="13"]',
                content: "Download the consultant's analysis",
                params: {
                    placement: "right",
                }
            },
            {
                target: '[data-v-step="14"]',
                content: "Make an apointment to discuss results",
                params: {
                    placement: "right",
                }
            },
            // {
            //     target: '[data-v-step="15"]',
            //     content: "Click to display time availability",
            //     params: {
            //         placement: "right",
            //     }
            // },
            // {
            //     target: '[data-v-step="16"]',
            //     content: "Select date and time according convenience",
            //     params: {
            //         placement: "right",
            //     }
            // }
        ]
    }),
    mutations: {

    },
    actions: {

    },
    getters: {
        getProjects: state => {
            return state.Projects
        },
        getUserConfigure: state => {
            return state.UserConfigure
        },

        getDashBoard: state => {
            return state.DashBoard
        },
    }
}